import { render, staticRenderFns } from "./AltRefusal.vue?vue&type=template&id=dc91b18a&"
import script from "./AltRefusal.vue?vue&type=script&lang=js&"
export * from "./AltRefusal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports